import { render, staticRenderFns } from "./save-dialog.vue?vue&type=template&id=5e3b4f24&scoped=true&"
import script from "./save-dialog.vue?vue&type=script&lang=js&"
export * from "./save-dialog.vue?vue&type=script&lang=js&"
import style0 from "./save-dialog.vue?vue&type=style&index=0&id=5e3b4f24&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3b4f24",
  null
  
)

export default component.exports